// extracted by mini-css-extract-plugin
export default {"backButton":"Details_backButton__UcVka","arrow":"Details_arrow__cWisV","content":"Details_content__g-179"};